const ErrorLevel = {
  verbose: "verbose",
  info: "info",
  warning: "warning",
  danger: "danger"
};
export default ErrorLevel;
